import { z } from 'zod';

export const RegisterMovementDTOSchema = z.object({
  type: z.enum(['in', 'out', 'transfer', 'adjust']),
  warehouseId: z.string().min(1, 'Warehouse ID is required'),
  productId: z.string().min(1, 'Product ID is required'),
  quantity: z.number().min(0.01, 'Quantity must be positive'),
  unitCost: z.number().min(0, 'Unit cost must be non-negative').optional(),
  unitPrice: z.number().min(0, 'Unit price must be non-negative').optional(),
  reference: z.object({
    type: z.enum(['PO', 'SO', 'TO', 'ADJ']),
    number: z.string(),
    externalId: z.string().optional(),
  }).optional(),
  notes: z.string().optional(),
  // For transfers
  destinationWarehouseId: z.string().optional(),
  // For adjustments
  reason: z.string().optional()
});

export type RegisterMovementDTO = z.infer<typeof RegisterMovementDTOSchema>;
